/**
 * Common measurement units shared across the application.
 * Single source of truth for all unit-of-measure inputs.
 * Values match the MeasurementUnit Prisma enum (uppercase).
 */
export const COMMON_UNITS = [
  'KG',
  'G',
  'HG',
  'LITRI',
  'ML',
  'CL',
  'PZ',
  'CONF',
  'SCATOLE',
  'BOTTIGLIE',
  'BUSTE',
  'VASCHETTE',
  'BARATTOLI',
  'LATTINE',
  'SACCHI',
  'CASSETTE',
  'BANCALI',
  'M',
  'CM',
  'MQ',
  'MC',
] as const;

/** User-friendly display labels for measurement units */
const UNIT_DISPLAY_LABELS: Record<string, string> = {
  KG: 'kg',
  G: 'g',
  HG: 'hg',
  LITRI: 'litri',
  ML: 'ml',
  CL: 'cl',
  PZ: 'pz',
  CONF: 'conf',
  SCATOLE: 'scatole',
  BOTTIGLIE: 'bottiglie',
  BUSTE: 'buste',
  VASCHETTE: 'vaschette',
  BARATTOLI: 'barattoli',
  LATTINE: 'lattine',
  SACCHI: 'sacchi',
  CASSETTE: 'cassette',
  BANCALI: 'bancali',
  M: 'm',
  CM: 'cm',
  MQ: 'm\u00B2',
  MC: 'm\u00B3',
};

/** Get display label for a measurement unit enum value */
export function getUnitLabel(unit: string): string {
  return UNIT_DISPLAY_LABELS[unit] ?? unit.toLowerCase();
}
